module.exports = __webpack_public_path__ + "img/framenew_box14.cf2844ba.jpg";